{
    "entityId": "b763a996-ff5f-4882-89d7-317e878ceb6b",
    "campaignId": "b763a996-ff5f-4882-89d7-317e878ceb6b",
    "workflowType": "Campaign",
    "isCompleted": false,
    "tasks": {
        "NewListing": {
            "order": 1,
            "taskType": "NewListing",
            "isLocked": true,
            "isCompleted": false,
            "steps": {
                "1": {
                    "name": "Prepare Listing Details",
                    "isCompleted": false,
                    "completeStepBy": "2025-09-25T05:13:26.7344966Z"
                },
                "2": {
                    "name": "Upload Photos",
                    "isCompleted": false,
                    "completeStepBy": "2025-10-23T05:13:26.7344966Z"
                },
                "3": {
                    "name": "Review Listing",
                    "isCompleted": false,
                    "completeStepBy": "2025-10-23T05:13:26.7344966Z"
                },
                "4": {
                    "name": "Publish Listing",
                    "isCompleted": false,
                    "completeStepBy": "2025-10-23T05:13:26.7344966Z"
                }
            }
        },
        "Launch": {
            "order": 2,
            "taskType": "Launch",
            "isLocked": true,
            "isCompleted": false,
            "steps": {
                "1": {
                    "name": "Launch Campaign",
                    "isCompleted": false,
                    "completeStepBy": "2025-10-23T05:13:26.7344966Z"
                },
                "2": {
                    "name": "Monitor Initial Response",
                    "isCompleted": false,
                    "completeStepBy": "2025-10-23T05:13:26.7344966Z"
                },
                "3": {
                    "name": "Adjust Marketing Strategy",
                    "isCompleted": false,
                    "completeStepBy": "2025-10-23T05:13:26.7344966Z"
                }
            }
        },
        "OnTheMarket": {
            "order": 3,
            "taskType": "OnTheMarket",
            "isLocked": true,
            "isCompleted": false,
            "steps": {
                "1": {
                    "name": "Monitor Market Activity",
                    "isCompleted": false,
                    "completeStepBy": "2025-10-23T05:13:26.7344966Z"
                },
                "2": {
                    "name": "Handle Inquiries",
                    "isCompleted": false,
                    "completeStepBy": "2025-10-23T05:13:26.7344966Z"
                },
                "3": {
                    "name": "Conduct Inspections",
                    "isCompleted": false,
                    "completeStepBy": "2025-10-23T05:13:26.7344966Z"
                },
                "4": {
                    "name": "Negotiate Offers",
                    "isCompleted": false,
                    "completeStepBy": "2025-10-23T05:13:26.7344966Z"
                }
            }
        }
    },
    "id": "b763a996-ff5f-4882-89d7-317e878ceb6b-Workflow",
    "type": "Workflow",
    "partitionKey": "Workflow",
    "eTag": "\"cf00ab27-0000-1a00-0000-68d337ce0000\"",
    "lastUpdate": "2025-09-24T00:14:05.6022619Z",
    "createdAt": "2025-09-24T00:14:05.6022551Z"
}